import React,{useState, useEffect} from 'react';
import GridComponent from "../../../../../component/grid/GridComponent.component";
import { AssesmentInterface } from '../interface/AssesmentInterface';
// import Graphic from "./component/Graphic.component";
import Graphic from '../../../../rating/graphic/component/Graphic.component';
import Rankings from './component/Rankings.component';
import {ListofMonsths} from '../../../../rating/utils/ListOfMonths';
import { getAssesments } from "../../Details.service";
import { useStore } from '../../../../../context/Store';
import {getUser} from '../../../../../core/auth/auth';
import ModalConfirm from '../component/ModalConfirm';
import { getUserStore } from '../../Product.service';
import useModal from '../../../../../hooks/useModal';
import { useHistory, useParams } from "react-router-dom";
import Progress from './../../../../../component/progress/Progress.component';

interface propsGrafic {
  name: string;
  NPS: number;
}

interface IUserStore {
  EV_WERKS:string | null | undefined;
}

interface ParamTypes {
  id:string;
}

export default function MyStore() {

  const [assessments, setAssessments] = useState<AssesmentInterface[]>([])
  const [request, setRequest] = useState<boolean>(true);
  const [listNPSLastMonsths, setListNPSLastMonsths] = useState<propsGrafic[]>([]);
  const [npsCurrentMonth, setNpsCurrentMonth] = useState<number|string>(0);
  const [myStoreInfo, setMyStoreInfo] = useState({
    EV_NAME1: "",
    EV_NAME2: "",
    EV_WERKS: "",
  })
  const [load, setLoad] = useState(true);
  const [open, addModal] = useModal();
  let { id } = useParams<ParamTypes>();

  const history = useHistory();

  const { nameStore, flag, selectedStore,  } = useStore();

  function lastMonth(date: Date, diff: number) {
    const d = new Date(date);
    d.setMonth(d.getMonth() + diff);
    return d;
  }

  function lastSixMonths(data: Date) {
    const datas = [];
    datas.push(data);
    for (let i = 1; i < 7; i++) {
      datas.push(lastMonth(data, i * -1));
    }
    return datas;
  }

  function getNPSCalc() {

      let date = new Date();
      let nowMonth = date.getMonth() + 1;
      let nowYear = date.getFullYear();

      let qtdPromotor = 0;
      let qtdNeutro = 0;
      let qtdDetrator = 0;

      let AvaliacoesDoMes = assessments.filter((item) => {
          let monthAndYear = formatDate(item.createdAt.toString(), true);
            if (monthAndYear[0] === nowMonth && monthAndYear[1] === nowYear) {
                return true;
            }
          return false;
      });

      AvaliacoesDoMes.forEach((item) => {
        if (item.vlrPerguntaNPS > 8) {
            qtdPromotor++;
        }

        if (item.vlrPerguntaNPS < 7) {
            qtdDetrator++;
        }
      })

      let percPromotor = Math.floor((qtdPromotor / AvaliacoesDoMes.length ) * 100);
      let percDetrator = Math.floor((qtdDetrator / AvaliacoesDoMes.length) * 100);

      const npsValue = percPromotor - percDetrator;
      let npsResult;

      if(isNaN(npsValue)) {
        npsResult = '';
      } else {
        npsResult = npsValue
      }
      setNpsCurrentMonth(npsResult);

  }

  function getNPSCalcLastMonths() {

    let date = new Date();

    let qtdPromotor = 0;
    let qtdNeutro = 0;
    let qtdDetrator = 0;

    const lastMonsths = lastSixMonths(date);


    let listMonths: number[] = [];
    let listNPS:any[] = [];
    let mediaNPS = 0;

    const listEvaluations = assessments.filter(item => item.id);

    if (listEvaluations.length !== 0) {
      lastMonsths.forEach((item) => {

        let AvaliacoesDoMesAnterior = [];

        let monthAndYear = formatDate(item.toString(), false);

        AvaliacoesDoMesAnterior = listEvaluations.filter((assessement) => {
          let monthAndYearAssessment = formatDate(assessement.createdAt.toString(), true);
            if (monthAndYear[0] === monthAndYearAssessment[0] && monthAndYear[1] === monthAndYearAssessment[1]) {
                return true;
            }
          return false;
        });

        if (AvaliacoesDoMesAnterior.length !== 0) {

          AvaliacoesDoMesAnterior.forEach((assessment) => {
            if (assessment.vlrPerguntaNPS > 8) {
                qtdPromotor++;
            }
            if (assessment.vlrPerguntaNPS === 7 || assessment.vlrPerguntaNPS === 8) {
                qtdNeutro++;
            }
            if (assessment.vlrPerguntaNPS < 7) {
                qtdDetrator++;
            }
          })
        }

        let npsDoMes = 0;
        let changedNPS = false;

        if (AvaliacoesDoMesAnterior.length !== 0) {
          let percPromotor = Math.floor((qtdPromotor / AvaliacoesDoMesAnterior.length ) * 100);
          let percDetrator = Math.floor((qtdDetrator / AvaliacoesDoMesAnterior.length) * 100);
          //let percNeutro = Math.floor((qtdNeutro / AvaliacoesDoMes.length) * 100);
          npsDoMes = percPromotor - percDetrator;

          mediaNPS = mediaNPS + npsDoMes;
          changedNPS = true;
        }

        listMonths.push(monthAndYear[0]);

        if (changedNPS) {
          listNPS.push(npsDoMes);
        } else {
          listNPS.push(undefined);
        }

        qtdPromotor = 0;
        qtdDetrator = 0;
        qtdNeutro = 0;
      })
    }

    let listMonthAndValue: propsGrafic[] = [];

    for (let i = 0; i < listMonths.length; i++) {
      let nameMonth = "";
      ListofMonsths.forEach((item) => {
        if (item.index === listMonths[i]) {
          nameMonth = item.name;
        }
      })
      let value = listNPS[i];

      listMonthAndValue.push({name: nameMonth, NPS: value});

    }

    listMonthAndValue.reverse();
    setListNPSLastMonsths(listMonthAndValue);
  }

  function getAnsweredReviews(): number {
    const evaluations = assessments.filter(item => item.flAvaliadoLoja);
    return evaluations.length;
  }

  const confirmModal = () => {
    addModal(!open)
    history.push(`/loja/${id}`);
  }

  function formatDate(date: string, currentMonth?: boolean): [number, number] {

    let year;
    let month;

    if (currentMonth === false) {
      let data = new Date(date);
      year = data.getFullYear();
      month = data.getMonth() + 1;
    } else {
      let data = date.substring(0, 10);
      year = data.substring(0, 4);
      month = data.substring(5, 7);
    }
    return [Number(month), Number(year)]
  }

  useEffect(() => {
    getPermission();

  }, [request])

   const getPermission = async () => {
    const userInfo = await getUser();
    const myStore:IUserStore|any = await getUserStore(userInfo.sAMAccountName).then((result) => result.data)

    setMyStoreInfo(myStore);

    // myStore.EV_WERKS
    if(myStore.EV_WERKS !== selectedStore.id) {
      addModal(true);
    } else {
      getAssessments();
      getNPSCalc();
      getNPSCalcLastMonths();
    }

    setLoad(false);
  }

  async function getAssessments() {
    const userInfo = await getUser();
      await getAssesments().then(res => {
        const avaliations = res.data.filter((assessment:AssesmentInterface) => assessment.idLoja === selectedStore.id && assessment.idUsuario !== userInfo.sAMAccountName)
        setAssessments(avaliations);
      }).catch((error) => {
        console.log("Erro ao consultar avaliações", error)
      }).finally(() => {
        setRequest(false);
      })
  }
  return (
    <>
      <ModalConfirm  open={!!open} handleClick={() => addModal('')}
        onClickSubmit={confirmModal}
        title="Usuário não pertence a loja selecionada!"
        subtitle1={`Loja selecionada: ${selectedStore.id} ${selectedStore.NomeCompleto}`}
        subtitle2={`Loja do usuário: ${myStoreInfo.EV_NAME2}`}
      />
      <Progress open={load} />
      {load === false &&
        <GridComponent alignItems={"flex-start"} justify={"space-between"}>
          {/* <Graphic data={listNPSLastMonsths} title='Histórico NPS Funcionários' value={dataValue1Result} /> */}
          <Graphic data={listNPSLastMonsths} title='Histórico NPS Funcionários' />
          <Rankings title='Rankings NPS Funcionários' qttAssessments={assessments.length} answeredReviews={getAnsweredReviews()} nps={npsCurrentMonth} />
        </GridComponent>
      }

      {/* <GridComponent alignItems={"flex-start"} justify={"space-between"} >
        <Graphic data={data2} title='Histórico NPS Clientes' value={dataValue2Result} />
        <Rankings title='Rankings NPS Clientes' />
      </GridComponent > */}
    </>
  );
}
